import React, { useEffect, useState } from 'react';
import { useServerStatus } from '../../contexts/ServerStatusContext';
import styles from './ServerStatusOverlay.module.css';

const ServerStatusOverlay: React.FC = () => {
  const { isBackendUp, message, failureId, lastChecked } = useServerStatus();
  const [dismissedFailureId, setDismissedFailureId] = useState<number | null>(null);

  useEffect(() => {
    if (!isBackendUp) {
      setDismissedFailureId(null);
    }
  }, [isBackendUp, failureId]);

  if (isBackendUp || dismissedFailureId === failureId) {
    return null;
  }

  const timestamp = lastChecked ? lastChecked.toLocaleTimeString() : null;

  return (
    <div className={styles.overlay} role="status" aria-live="assertive">
      <div className={styles.card}>
        <div className={styles.badge}>Server on break</div>
        <h2 className={styles.title}>The keepers are away</h2>
        <p className={styles.copy}>{message || 'We cannot reach the realm right now. Please try again shortly.'}</p>
        {timestamp && <p className={styles.time}>Last check: {timestamp}</p>}
        <div className={styles.actions}>
          <button type="button" onClick={() => window.location.reload()}>Retry now</button>
          <button type="button" onClick={() => setDismissedFailureId(failureId)}>Keep exploring</button>
        </div>
      </div>
    </div>
  );
};

export default ServerStatusOverlay;
